import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { responsiveFieldStyle } from '../form-field.styles'

export const root = (theme: Theme) => css`
  ${theme.presentation.field.helper}
  p { ${responsiveFieldStyle(theme.presentation.field.helperText)} }
`

export const error = (theme: Theme) => css`
  color: ${theme.palette.error.main};
`

export const disabled = (theme: Theme) => css`
  color: ${theme.presentation.field.disabledCaptionColor};
`
